import { render, staticRenderFns } from "./CommentsBlogsCreate.vue?vue&type=template&id=7b1db2cc&scoped=true&"
import script from "./CommentsBlogsCreate.vue?vue&type=script&lang=js&"
export * from "./CommentsBlogsCreate.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBlogsCreate.vue?vue&type=style&index=0&id=7b1db2cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1db2cc",
  null
  
)

export default component.exports